import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n/I18nProvider';

export function RideOperationsTabs(): React.ReactElement {
  const { t } = useI18n(); const { pathname } = useLocation();
  const bookings = pathname.startsWith('/rides/bookings');
  return <nav aria-label={t('bookings.tabs')} className="mb-6 flex gap-6 border-b border-gray-200">
    {[[false, '/rides', t('nav.rides')], [true, '/rides/bookings', t('bookings.tab')]].map(([selected, path, label]) =>
      <Link key={String(path)} to={String(path)} aria-current={bookings === selected ? 'page' : undefined}
        className={`border-b-2 px-1 pb-3 text-sm font-semibold ${bookings === selected ? 'border-gray-900 text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-900'}`}>{label}</Link>)}
  </nav>;
}
